import React, { useState, useEffect, useContext } from 'react';
import Layout from './Layout';
import EventContext from '../contexts/EventContext';
import useApiUrlTranslation from './useApiUrlTranslation';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/en-gb';
import Loader from './Loader';
import { ChevronDown, ChevronUp, Mail, Phone, Search, Tag, Link as LinkIcon, ArrowLeft, List, LayoutGrid } from 'lucide-react';
import { Link } from 'react-router-dom';
import RegistrationDashboardLayout from './RegistrationDashboardLayout';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
// Composant pour un participant individuel avec détails dépliables
const ParticipantItem = ({ participant, slot, event, viewType }) => {
    const [isDetailsVisible, setIsDetailsVisible] = useState(true);
    const { prestas } = participant; // Les prestations sont directement dans l'objet participant
    const { i18n } = useApiUrlTranslation();

    const formUrl = event && participant.contact?.id_contact
        ? `/events/${event.id_event}/signup/enregistrement-webcast/c/${participant.contact.id_contact}?form-name=enregistrement-webcast&formisvisible=1&id_formulaire=105&lng=${i18n.language}`
        : null;



    if (viewType === "liste") {
        return (
            <tr className="border-b dark:border-neutral-700 hover:bg-blue-50/50 dark:hover:bg-blue-900/10 transition-colors even:bg-gray-50/60 dark:even:bg-neutral-800/30">
                <td className="px-4 py-3">
                    <div className="flex flex-col">
                        <span className="font-bold text-gray-800 dark:text-white">{participant.contact.prenom} {participant.contact.nom}</span>


                        <span className="text-sm text-neutral-600 dark:text-neutral-400">{participant.conferencier_statut.libelle}</span>
                    </div>
                </td>
                <td>{participant.contact.societe}</td>

                <td>   {prestas && prestas.length > 0 && (
                    <div className="mt-2 space-x-2">
                        {prestas.map(presta => (
                            <span key={presta.id_presta} className="inline-flex items-center bg-gray-100 dark:bg-neutral-800 text-gray-700 dark:text-neutral-300 text-xs font-medium px-2.5 py-0.5 rounded-full">
                                <Tag size={12} className="mr-1" />
                                {presta.presta_nom}
                            </span>
                        ))}
                    </div>
                )}</td>

                <td>
                    {participant.conf_event?.conf_event_lang?.cel_titre}

                    {slot && (
                        <div className="mt-2 text-sm text-blue-700 dark:text-blue-400 font-semibold">
                            Créneau: {moment(slot.conf_event_date).format('ddd D MMM')} à {slot.heure_debut_local} - {slot.salle.salle_nom}
                        </div>
                    )}

                </td>
                <td> {participant.contact.auteur.prenom} {participant.contact.auteur.nom}</td>
                <td><a
                    className="text-blue-600 hover:underline text-sm"
                    target="_blank" rel="noopener noreferrer" href={`https://www.event2one.com/screen_manager/content/contact/?&content=fiche_production&target=obs&id_event_ligne=${event.event_ligne.id_event_ligne}&id_contact=${participant.contact.id_contact}&fiche_production_mode=intervenant`}>Fiche production</a></td>
            </tr>
        );
    }

    return (
        <li className="bg-white dark:bg-neutral-900 shadow-sm rounded-lg mb-3 border dark:border-neutral-700">
            <div className="p-4 flex items-center justify-between cursor-pointer" onClick={() => setIsDetailsVisible(!isDetailsVisible)}>
                <div className="flex-grow">
                    <p className="font-bold text-gray-800 dark:text-white">{participant.contact.prenom} {participant.contact.nom}</p>
                    <p className="text-sm text-gray-600 dark:text-neutral-300 font-semibold">{participant.contact.societe}</p>

                    {prestas && prestas.length > 0 && (
                        <div className="mt-2 space-x-2">
                            {prestas.map(presta => (
                                <span key={presta.id_presta} className="inline-flex items-center bg-gray-100 text-gray-700 text-xs font-medium px-2.5 py-0.5 rounded-full">
                                    <Tag size={12} className="mr-1" />
                                    {presta.presta_nom}
                                </span>
                            ))}
                        </div>
                    )}

                    {slot && (
                        <div className="mt-2 text-sm text-blue-700 dark:text-blue-400 font-semibold">
                            Créneau: {moment(slot.conf_event_date).format('ddd D MMM')} à {slot.heure_debut_local} - {slot.salle.salle_nom}
                        </div>
                    )}
                </div>
                <button
                    className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-neutral-700 focus:outline-none"
                    aria-expanded={isDetailsVisible}
                >
                    {isDetailsVisible ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </button>
            </div>
            {isDetailsVisible && (
                <div className="border-t border-gray-200 dark:border-neutral-700 p-4 bg-gray-50 dark:bg-neutral-800">
                    <h4 className="text-sm font-semibold text-gray-700 dark:text-neutral-200 mb-2">Coordonnées</h4>
                    <div className="space-y-2 text-sm">
                        {participant.contact.email && (
                            <div className="flex items-center">
                                <Mail size={16} className="mr-2 text-gray-400 dark:text-neutral-500" />
                                <a href={`mailto:${participant.contact.email}`} className="text-blue-600 hover:underline">{participant.contact.email}</a>
                            </div>
                        )}
                        {participant.contact.tel && (
                            <div className="flex items-center">
                                <Phone size={16} className="mr-2 text-gray-400 dark:text-neutral-500" />
                                <span>{participant.contact.tel}</span>
                            </div>
                        )}
                        {formUrl && (
                            <div className="flex items-center">
                                <LinkIcon size={16} className="mr-2 text-gray-400 dark:text-neutral-500" />
                                <Link to={formUrl} target="_blank" className="text-blue-600 hover:underline">
                                    Voir le formulaire d'inscription
                                </Link>
                            </div>
                        )}
                        {!participant.contact.email && !participant.contact.tel && !formUrl && (
                            <p className="text-gray-500 dark:text-neutral-400">Aucune coordonnée disponible.</p>
                        )}
                    </div>
                </div>
            )}
        </li>
    );
};

const RegistrationDashbordDetails = () => {
    const { apiUrlTranslation } = useApiUrlTranslation();
    const [allParticipants, setAllParticipants] = useState([]);
    const [slotsMap, setSlotsMap] = useState(new Map());
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const { currentEvent } = useContext(EventContext);

    const { idEvent } = useParams();

    const [viewType, setViewType] = useState("liste"); // "liste" ou "carte"


    const handleViewTypeChange = (type) => {
        setViewType(type);
    };

    useEffect(() => {


        const fetchAndProcessData = async () => {
            try {
                setLoading(true);
                const [partenairesRes, confEventRes] = await Promise.all([
                    fetch(`${apiUrlTranslation}?action=getPartenairesLight&params=AND cf.id_event=${idEvent} `),
                    fetch(`${apiUrlTranslation}?action=getConfeventLight&id_event=${idEvent}`)
                ]);

                if (!partenairesRes.ok || !confEventRes.ok) throw new Error('Erreur réseau lors de la récupération des données');

                let partenaires = await partenairesRes.json();
                const allSlots = await confEventRes.json();

                const localSlotsMap = new Map(allSlots.map(s => [parseInt(s.id_conf_event, 10), s]));
                setSlotsMap(localSlotsMap);

                partenaires.sort((a, b) =>
                    `${a.contact.nom} ${a.contact.prenom}`.localeCompare(`${b.contact.nom} ${b.contact.prenom}`)
                );

                // --- Récupération et enrichissement avec les prestations ---
                if (partenaires.length > 0) {
                    const contactIds = partenaires.map(p => p.contact.id_contact).join(',');
                    const prestaRes = await fetch(`${apiUrlTranslation}?action=getPrestaList&params=WHERE id_contact IN (${contactIds})`);

                    if (prestaRes.ok) {
                        const prestaList = await prestaRes.json();
                        const localPrestasMap = new Map();
                        prestaList.forEach(presta => {
                            const contactId = (presta.id_contact);
                            if (!localPrestasMap.has(contactId)) {
                                localPrestasMap.set(contactId, []);
                            }
                            localPrestasMap.get(contactId).push(presta);
                        });

                        // Enrichir chaque participant avec ses prestations
                        const enrichedParticipants = partenaires.map(p => ({
                            ...p,
                            prestas: localPrestasMap.get(String(p.contact.id_contact)) || []

                        }));

                        console.log('Participants enrichis:', enrichedParticipants);
                        setAllParticipants(enrichedParticipants); // Mise à jour unique avec les données complètes
                    } else {
                        // En cas d'erreur, on met quand même à jour avec des prestas vides
                        setAllParticipants(partenaires.map(p => ({ ...p, prestas: [] })));
                    }
                } else {
                    setAllParticipants([]); // Aucun participant
                }

            } catch (err) {
                setError(err.message);
                console.error("Erreur lors de la récupération des détails:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchAndProcessData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idEvent]);

    const filteredParticipants = allParticipants.filter(p => {
        const searchTermLower = searchTerm.toLowerCase();
        const fullName = `${p.contact.prenom} ${p.contact.nom}`.toLowerCase();
        const company = p.contact.societe ? p.contact.societe.toLowerCase() : '';
        return fullName.includes(searchTermLower) || company.includes(searchTermLower);
    });

    if (!currentEvent) return <Layout><div className="text-center p-10 m-10"><Loader /></div></Layout>;
    if (loading) return <Layout className="bg-white"><div className="text-center p-10 m-10"><Loader /></div></Layout>;
    if (error) return <Layout><div className="text-center p-10 text-red-500">Erreur: {error}</div></Layout>;

    return (
        <RegistrationDashboardLayout>
            <div className="p-8 bg-gray-50 dark:bg-neutral-950 min-h-screen">
                <header className="mb-8">
                    <div className="pt-5">
                        <Link
                            target="_blank"
                            rel="noreferrer"
                            to={`/events/${idEvent}/registration-dashboard`}
                            className="inline-flex items-center text-sm font-medium text-blue-600 hover:underline mb-4"
                        >
                            <ArrowLeft className="h-4 w-4 mr-2" />
                            Retour au tableau de bord
                        </Link>
                    </div>
                    <h1 className="text-3xl font-bold text-gray-800 dark:text-white pt-5">Liste des Inscrits - {currentEvent?.nom}</h1>
                    <p className="text-gray-600 dark:text-neutral-300 mt-1">Recherchez et consultez les détails de tous les participants.</p>
                </header>


                <div className="bg-white dark:bg-neutral-900 flex w-full items-center gap-4 mb-6 p-3 justify-between rounded-xl shadow-sm">
                    <div className="flex items-center gap-2 ">
                        <button
                            onClick={() => handleViewTypeChange("liste")}
                            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors text-sm font-medium ${viewType === 'liste'
                                ? 'bg-gray-600 text-white'
                                : 'bg-gray-200 dark:bg-neutral-700 text-gray-700 dark:text-neutral-200 hover:bg-gray-300 dark:hover:bg-neutral-600'
                                }`}
                        >
                            <List size={16} />
                            Vue Liste
                        </button>
                        <button
                            onClick={() => handleViewTypeChange("carte")}
                            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors text-sm font-medium ${viewType === 'carte'
                                ? 'bg-gray-600 text-white'
                                : 'bg-gray-200 dark:bg-neutral-700 text-gray-700 dark:text-neutral-200 hover:bg-gray-300 dark:hover:bg-neutral-600'
                                }`}
                        >
                            <LayoutGrid size={16} />
                            Vue grille
                        </button>
                    </div>
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-neutral-500" size={20} />
                        <input
                            type="text"
                            placeholder="Rechercher par nom ou société..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full max-w-md p-3 pl-10 border border-gray-300 dark:border-neutral-700 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-neutral-800 dark:text-white dark:placeholder-neutral-500"
                        />
                    </div>
                </div>
                <div>
                    <h2 className="text-xl font-bold text-gray-800 dark:text-white mb-4">
                        {filteredParticipants.length} participant(s)
                    </h2>


                    {viewType === "carte" && <ul>
                        {filteredParticipants.length > 0 ? (
                            filteredParticipants.map(participant => {
                                const confEventId = participant.id_conf_event ? parseInt(participant.id_conf_event.id_conf_event, 10) : null;
                                const slot = confEventId ? slotsMap.get(confEventId) : null;
                                return <ParticipantItem
                                    viewType={viewType}
                                    key={participant.id_conferencier} participant={participant} slot={slot} event={currentEvent} />;
                            })
                        ) : (
                            <p className="text-gray-500 dark:text-neutral-400 bg-white dark:bg-neutral-900 p-6 rounded-lg shadow-sm">Aucun participant ne correspond à votre recherche.</p>
                        )}
                    </ul>
                    }


                    {viewType === "liste" && <table className="min-w-full bg-white dark:bg-neutral-900 shadow-sm rounded-lg overflow-hidden">

                        <thead className="bg-gray-100 dark:bg-neutral-800">
                            <tr className="border-b dark:border-neutral-700">
                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 dark:text-neutral-300">Contact </th>
                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 dark:text-neutral-300">Société</th>

                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 dark:text-neutral-300">Solution</th>

                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 dark:text-neutral-300">Session</th>
                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 dark:text-neutral-300">Coordinateur</th>
                                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 dark:text-neutral-300"> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredParticipants.length > 0 ? (
                                filteredParticipants.map(participant => {
                                    const confEventId = participant.id_conf_event ? parseInt(participant.id_conf_event.id_conf_event, 10) : null;
                                    const slot = confEventId ? slotsMap.get(confEventId) : null;
                                    return <ParticipantItem
                                        viewType={viewType}
                                        key={participant.id_conferencier} participant={participant} slot={slot} event={currentEvent} />;
                                })
                            ) : (
                                <p className="text-gray-500 dark:text-neutral-400 bg-white dark:bg-neutral-900 p-6 rounded-lg shadow-sm">Aucun participant ne correspond à votre recherche.</p>
                            )}
                        </tbody>
                    </table>
                    }


                </div>
            </div>
        </RegistrationDashboardLayout>
    );
};

export default RegistrationDashbordDetails;